module.exports = __webpack_public_path__ + "img/collection-weddingRingsGold.174d9ec.jpg";